import { CNH_REGEX, CNH_REPEATED_REGEX } from "../constants";

export const isValidCnh = (val?: string) => {
	if (!val) {
		return true;
	}

	if (!CNH_REGEX.test(val)) {
		return false;
	}

	if (CNH_REPEATED_REGEX.test(val)) {
		return false;
	}

	return true;
};

export const isValidDate = (val?: string) => {
	if (!val) {
		return true;
	}
	return !Number.isNaN(new Date(val).getTime());
};
